function FormsPage() {
    return <div>This is the Forms content</div>
  }

export default FormsPage